













































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapActions, mapGetters, mapState } from 'vuex';
import ReservationSummary from '@/components/ReservationSummary.vue';
import MarkdownText from '@/components/ui/MarkdownText.vue';
import Reservation from '@/models/Reservation';
import { getOrString } from '@/utilities/helpers';

const Setup = Vue.extend({
	components: {
		MarkdownText,
		ReservationRegistration: () => import('@/components/ReservationRegistration.vue'),
		ReservationSummary,
	},
	computed: {
		...mapState(['paths']),
		...mapState('reservation', ['reservation']),
		...mapGetters('location', ['location', 'settings']),
		...mapGetters('reservation', ['customerExists', 'editLink', 'voucherLink']),
	},
	methods: {
		...mapActions('reservation', ['getQuotes']),
	},
});
@Component({
	components: { MarkdownText },
})
export default class ReservationConfirmation extends Setup {
	// State
	public paths!: App.Paths;
	public reservation!: Reservation;

	// Getters
	public customerExists!: boolean;
	public editLink!: string;
	public location!: Locations.Location;
	public settings!: Locations.Settings;
	public voucherLink!: string;

	// Actions
	public getQuotes!: (payload: any) => Promise<any>;

	public get contactMessage(): string {
		let message = 'If you have any questions regarding your reservation, you may ';
		let emailLink = '';
		let phoneLink = '';

		if (this.locationEmail) {
			emailLink = `<a href="mailto:${this.locationEmail}">${this.locationEmail}</a>`;
		}

		if (this.details.phone) {
			phoneLink = `<a href="tel:${this.details.phone}">${(this.$options.filters as any).phone(this.details.phone)}</a>`;
		}

		if (this.locationEmail && this.details.phone) {
			message += `call us at ${phoneLink} or email at ${emailLink}.`;
		} else if (this.locationEmail) {
			message += `email us at ${emailLink}.`;
		} else if (this.details.phone) {
			message += `call us at ${phoneLink}.`;
		}

		return this.locationEmail || this.details.phone ? message : '';
	}

	public get details(): Locations.Details {
		return this.$store.getters['location/details'];
	}

	public get locationEmail(): string {
		return this.$store.getters['location/email'];
	}

	// Hooks
	public created() {
		if (this.settings.confirmation_url) {
			const params = {
				loc_address: this.details.address,
				loc_address2: this.details.address2,
				loc_city: this.details.city,
				loc_state: this.details.state,
				loc_zip: this.details.zip,
				loc_airport_code: this.details.airport_code,
				loc_id: this.details.id,
				loc_name: this.details.name,
				last_name: this.reservation.last_name,
				first_name: this.reservation.first_name,
				phone: this.reservation.phone3 || this.reservation.phone,
				email: this.reservation.email,
				res_number: this.reservation.reservation,
				res_savings: this.reservation.quote.savings,
				res_subtotal: this.reservation.quote.parking_net,
				res_sales_tax: this.reservation.quote.sales_taxes_subtotal,
				res_airport_tax: this.reservation.quote.airport_taxes_subtotal,
				res_total: this.reservation.quote.grand_total,
				res_start_date: this.reservation.start_date,
				res_end_date: this.reservation.end_date,
				res_edit_link: `${this.paths.reservationEdit}?id=${this.reservation.uid}&loc=${this.location.code}-${this.details.id}&reservation=${this.reservation.reservation}`,
			} as { [key: string]: string|number };

			let redirect_url = this.settings.confirmation_url;

			const position = this.settings.confirmation_url.search('{amount}');
			if (position !== -1) {
				let url = redirect_url.substring(0, position);
				url = url.concat('amount=');
				redirect_url = url.concat(params.res_total.toString());
			}

			const form = document.createElement('form');
			form.setAttribute('method', 'POST');
			form.setAttribute('action', redirect_url);

			Object.keys(params).forEach((key: string) => {
				const input = document.createElement('input');
				input.setAttribute('type', 'hidden');
				input.setAttribute('name', key);
				input.value = String(params[key]);

				form.appendChild(input);
			});

			document.body.appendChild(form);

			setTimeout(() => {
				form.submit();
			}, 1000);
		}
	}
}
